import { render, staticRenderFns } from "./SxswEvent.vue?vue&type=template&id=6600ef6a&"
import script from "./SxswEvent.vue?vue&type=script&lang=js&"
export * from "./SxswEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports